export default __webpack_public_path__ + "CarePlayLogo2024.png";